import React from "react"

const MapboxColorPicker = ({name, color}) => {
    return (
        <>
        <div className="input-group colorpicker-component">
           <input
             type="text"
             className="form-control color-picker-settings-input"
             name={name}
             defaultValue={color}
           />
           <span className="input-group-addon">
             <i style={{ backgroundColor: color }}></i>
           </span>
         </div>
       </>
    )
}

export default MapboxColorPicker